// extracted by mini-css-extract-plugin
module.exports = {"slide":"Banner_slide__HFid3"};